import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

// Server functions that wrap the expertise database queries
// These ensure DB operations only happen on the server

export const getExpertiseCategories = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getExpertiseCategories: dbGetExpertiseCategories } = await import(
      "~/lib/server/expertise"
    );
    return dbGetExpertiseCategories();
  },
);

export const getExpertiseSubcategories = createServerFn({
  method: "GET",
}).handler(async () => {
  const { getExpertiseSubcategories: dbGetExpertiseSubcategories } =
    await import("~/lib/server/expertise");
  return dbGetExpertiseSubcategories();
});

export const getCategoryBySlug = createServerFn({ method: "GET" })
  .validator(z.object({ slug: z.string() }))
  .handler(async ({ data }) => {
    const { getCategoryBySlug: dbGetCategoryBySlug } = await import(
      "~/lib/server/expertise"
    );
    return dbGetCategoryBySlug(data.slug);
  });

export const getSubcategoryBySlug = createServerFn({ method: "GET" })
  .validator(z.object({ slug: z.string() }))
  .handler(async ({ data }) => {
    const { getSubcategoryBySlug: dbGetSubcategoryBySlug } = await import(
      "~/lib/server/expertise"
    );
    return dbGetSubcategoryBySlug(data.slug);
  });

export const getSubcategoriesByCategorySlug = createServerFn({ method: "GET" })
  .validator(z.object({ categorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getSubcategoriesByCategorySlug: dbGetSubcategoriesByCategorySlug } =
      await import("~/lib/server/expertise");
    return dbGetSubcategoriesByCategorySlug(data.categorySlug);
  });

export const getSubcategoriesInCategoryWithCoaches = createServerFn({
  method: "GET",
})
  .validator(z.object({ categorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getSubcategoriesByCategorySlug: dbGetSubcategoriesByCategorySlug } =
      await import("~/lib/server/expertise");
    return dbGetSubcategoriesByCategorySlug(data.categorySlug);
  });

export const getCategoriesInCityWithCoaches = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCategoriesInCityWithCoaches: dbGetCategoriesInCityWithCoaches } =
      await import("~/lib/server/expertise");
    return dbGetCategoriesInCityWithCoaches(data.citySlug);
  });

export const getSubcategoriesInCityWithCoaches = createServerFn({
  method: "GET",
})
  .validator(z.object({ citySlug: z.string() }))
  .handler(async ({ data }) => {
    const {
      getSubcategoriesInCityWithCoaches: dbGetSubcategoriesInCityWithCoaches,
    } = await import("~/lib/server/expertise");
    return dbGetSubcategoriesInCityWithCoaches(data.citySlug);
  });

export const getCoachExpertise = createServerFn({ method: "GET" })
  .validator(z.object({ coachId: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachExpertise: dbGetCoachExpertise } = await import(
      "~/lib/server/expertise"
    );
    return dbGetCoachExpertise(data.coachId);
  });

export const getCoachExpertiseData = createServerFn({ method: "GET" })
  .validator(z.object({ coachId: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachExpertiseData: dbGetCoachExpertiseData } = await import(
      "~/lib/server/expertise"
    );
    return dbGetCoachExpertiseData(data.coachId);
  });

export const updateCoachExpertise = createServerFn({ method: "POST" })
  .validator(
    z.object({
      coachId: z.string(),
      primaryExpertise: z.array(z.string()),
      secondaryExpertise: z.array(z.string()),
    }),
  )
  .handler(async ({ data }) => {
    const { updateCoachExpertise: dbUpdateCoachExpertise } = await import(
      "~/lib/server/expertise"
    );
    return dbUpdateCoachExpertise(
      data.coachId,
      data.primaryExpertise,
      data.secondaryExpertise,
    );
  });
